<template>
  <div class="infobox">
    <div class="image">
      <slot name="image" />
    </div>
    <div class="text-content">
      <div class="title">
        <slot name="title" />
      </div>
      <div class="text-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
};
</script>

<style lang="scss" scoped>
.infobox {
  border: 2px solid $brand-orange;
  border-radius: $border-radius-small;
  padding: $spacing-small;

  font-size: 16px;

  width: 100%;
  margin: $spacing-medium auto;

  display: grid;
  grid-template-columns: repeat(2, auto);

  @include media("<medium") {
    width: 100%;
  }
}

.text-body {
  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }
}

.image {
  margin: 0 $spacing-small 1rem 0;

  &:empty {
    margin: 0;
  }
}

.title {
  color: $brand-orange;
  font-size: 20px;
  font-weight: $font-bold;
}
</style>
